<template>
  <div class="mailing-edit">
    <div class="display-1 font-weight-bold pb-3">
      {{
        `Отправка СМС на ${param.data.count} 
        ${word(param.data.count, "номер", ["", "а", "ов"])}`
      }}
    </div>
    <div v-if="error" class="error--text pb-3 font-weight-medium">
      {{ error }}
    </div>
    <div class="subtitle-2 pb-3 font-weight-medium">
      <span>
        1 СМС содержит до 70 знаков. Сверх этого значения будет считаться как 2
        и более СМС.
      </span>
    </div>
    <v-form ref="form" v-model="formValid" class="pt-3">
      <label class="d-flex">
        <div class="text-sm-left align-self-start">Текст СМС</div>
        <div class="text-sm-right align-self-end">
          {{ `${numberOfSigns}/70 (на ${countSms} СМС)` }}
        </div>
      </label>
      <v-textarea
        v-model="formParams.message"
        :rules="[rules.required]"
        placeholder="Введите текст СМС"
        textarea
        solo
      ></v-textarea>
      <div class="subtitle-2 font-weight-medium">
        <div class="d-flex pb-3">
          <div class="flex-none">Всего отправить</div>
          <div class="mx-2 dashed"></div>
          <div class="flex-none">{{ countAllSms }} СМС</div>
        </div>
        <div class="d-flex pb-3">
          <div class="flex-none">В рамках тарифа</div>
          <div class="mx-2 dashed"></div>
          <div class="flex-none">{{ tariffPlan }} СМС</div>
        </div>
        <div class="d-flex pb-4">
          <div class="flex-none">Сверх тарифа</div>
          <div class="mx-2 dashed"></div>
          <div class="flex-none">
            {{ overTariffPlan }} СМС (по {{ hotspot.sms.priceMoreCount }} ₽/шт.)
          </div>
        </div>
        <div class="d-flex title font-weight-bold">
          <div class="flex-none">К оплате</div>
          <div class="mx-2 dashed"></div>
          <div class="flex-none" style="color: #00CB9A;">
            {{ hotspot.sms.priceMoreCount * overTariffPlan }} ₽
          </div>
        </div>
      </div>
      <div class="d-flex pt-2 mt-4 pb-3">
        <v-btn @click="send" class="primary mx-0">
          Отправить
        </v-btn>
        <div class="valign-middle text-sm-right align-self-center">
          <button
            @click="cancel"
            type="button"
            class="subtitle-1 font-weight-medium"
          >
            <span class="dashed dashed--2">
              Отменить
            </span>
          </button>
        </div>
      </div>
    </v-form>
  </div>
</template>
<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";

export default {
  name: "SmsMailingForm",

  data: () => ({
    // ошибка
    error: false,
    // флаг проверки поля
    formValid: false,
    // правило валидации
    rules: {
      required: v => !!v || "Поле обязательно для заполнения"
    },
    // параметры формы
    formParams: { message: "" }
  }),
  computed: {
    // объект с данными хотспота
    hotspot() {
      return this.$store.getters.getHotspot(this.param.hotspot_id);
    },
    // колиечство знаков в смс
    numberOfSigns() {
      return this.formParams.message.length;
    },
    // количество смс
    countSms() {
      return Math.ceil(this.formParams.message.length / 70);
    },
    // всего смс
    countAllSms() {
      return this.countSms * this.param.data.count;
    },
    // в рамках тарифа
    tariffPlan() {
      let value = this.countAllSms;
      if (this.countAllSms < this.hotspot.sms.balance) {
        value = this.countAllSms;
      } else {
        value = this.hotspot.sms.balance;
      }
      return value;
    },
    // сверх тарифа
    overTariffPlan() {
      let value = 0;
      if (this.countAllSms > this.hotspot.sms.balance) {
        value = this.countAllSms - this.hotspot.sms.balance;
      }
      return value;
    }
  },
  props: {
    //  параметры для отправки смс
    param: {
      type: Object,
      required: true,
      default: function() {
        return { title: "Отправка СМС" };
      }
    }
  },

  methods: {
    // отправка смс
    send() {
      if (!this.param.data.phones) this.getPhones();
      else this.sendSms();
    },
    // получение телефонов для отправки смс всем клиентам
    getPhones() {
      // сначала в методе будем получать все телефоны
      const data = {
        params: this.param.params,
        type: this.param.type,
        cl_service_id: this.$store.getters.hotspotList.find(
          item => item.id === this.param.hotspot_id
        ).cl_service_id,
        message: this.formParams.message
      };
      RequestApi.getPhones(data)
        .then(result => {
          this.param.data.phones = result;
          this.sendSms();
        })
        .catch(err => {
          this.error = err;
        });
    },
    // метод отправки смс выбранным клиентам
    sendSms() {
      if (this.$refs.form.validate()) {
        const data = {
          phones: this.param.data.phones,
          cl_service_id: this.$store.getters.hotspotList.find(
            item => item.id === this.param.hotspot_id
          ).cl_service_id,
          message: this.formParams.message
        };
        // console.log(this.param.data.phones);
        return new Promise(() => {
          RequestApi.sendSms(data)
            .then(() => {
              this.$emit("closeDialog");
              // открываем сообщение
              this.$store.dispatch("popupInfoOpen", {
                text: "Сообщения отправлены"
              });
            })
            .catch(err => {
              this.error = err;
            });
        });
      }
    },
    // отмена
    cancel() {
      this.$emit("closeDialog");
    },
    // получение слова с нужным окончанием в зависимости от числа
    word(count, wordWithoutEnd, endingArray) {
      return `${wordWithoutEnd}${Common.endingWord(count, endingArray)}`;
    }
  }
};
</script>
